// =========================================================
// services/homeContentApi.js
//
// The public landing page's CMS and its contact form.
//   public:  fetchPublicHomeContent, fetchPreviewHomeContent, submitContactMessage
// The admin's side: Pages/Super Admin/home-content/api.js.
// =========================================================
import api from "../utils/api";

// Public, no auth — the landing page and its footer.
export async function fetchPublicHomeContent() {
    const { data } = await api.get("/home-content");
    return data.content;
}

// The draft on the real page, for the admin editor's preview: { content, preview }, where
// preview is "draft", "live" (no draft to show) or "invalid" (the live page, and a bad token).
export async function fetchPreviewHomeContent(token) {
    const { data } = await api.get("/home-content", { params: { preview: token } });
    return { content: data.content, preview: data.preview };
}

// Public contact form → platform_leads. Rate limited per IP server-side.
export async function submitContactMessage(payload) {
    const { data } = await api.post("/public/contact", payload);
    return data; // { success, message }
}

// Render-time fallback for the public page while (or if) the fetch fails —
// the same shape as the CMS document, never a data source.
export const EMPTY_HOME_CONTENT = {
    hero: { title: "", titleAccent: "", subtitle: "", primaryButton: { text: "", href: "/auth" } },
    features: { eyebrow: "", title: "", subtitle: "", items: [] },
    pricing: { eyebrow: "", title: "", subtitle: "", currency: "EGP", footnote: "", plans: [] },
    testimonials: { eyebrow: "", title: "", subtitle: "", items: [] },
    contact: { eyebrow: "", titleAccent: "", titleRest: "", subtitle: "", emailLabel: "", email: "", phoneLabel: "", phone: "" },
    seo: { metaTitle: "", metaDescription: "", ogImage: "", canonicalUrl: "" },
    social: { facebook: "", instagram: "", linkedin: "", x: "", youtube: "", tiktok: "" },
};
